import React from 'react';
import Home from './components/scripts/Home';
function App() {
	// const handleMoves=(ev)=>{
	// 	ev.target.style.transform=`translateY${ev.clientY-25}px`;
	// 	ev.target.style.transform=`translateX${ev.clientX-25}px`;
	// }
return (
	<div id='parent'  >
		{/* <div id="foo" class="ball" ></div> */}
		<Home/>
		{/* <Contacts */}
		
	</div>
);
}

export default App;

